export default "__VITE_ASSET__BoPEkJHz__"